import React from "react";

const INSS = () => {
  return (
    <div style={{ padding: "2rem" }}>
      <h1>Rota /inss funcionando ✅</h1>
    </div>
  );
};

export default INSS;